export default __webpack_public_path__ + "static/media/home-travel-agency-packages-img04.d6bf7dbe.jpg";